import { RefereeService } from './referee.service';
import { Component, Inject, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-referee',
  templateUrl: './referee.component.html',
  styleUrls: ['./referee.component.css']
})
export class RefereeComponent implements OnInit {

  payload = []

  constructor(private refereeService: RefereeService, @Inject(DOCUMENT) private _document: Document) { }

  ngOnInit(): void {
  }

  onSubmit(data){
    this.payload = [data]
    this.refereeService.saveReferee(this.payload)
    .subscribe( response => {
      if(response['id'] !== null){
        Swal.fire(
          'Done!',
          'Referee is saved!',
          'success'
        ).then((result) => {
          if (result.value) {
            this.delay(100)
          }
        })
      }
    })
    // this.delay(300);
  }

  async delay(ms: number) {
    await new Promise( resolve => setTimeout(resolve, ms) );
    await this._document.defaultView.location.reload();   //this.getExp3();//Promise(resolve => setTimeout(()=>resolve(), ms)).then(()=>console.log("fired"));
  }

}
